var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "h-screen flex w-full bg-img vx-row no-gutter items-center justify-center",
      style: { "background-image": "url(" + _vm.imagenFondo + ") !important" },
      attrs: { id: "page-login" }
    },
    [
      _c("img", {
        style: _vm.logoStyle,
        attrs: { src: _vm.ingresoLogo.imagen, id: "logo" }
      }),
      _c(
        "div",
        {
          staticClass: "vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4"
        },
        [
          _c("vx-card", [
            _c(
              "div",
              {
                staticClass: "full-page-bg-color",
                attrs: { slot: "no-body" },
                slot: "no-body"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "vx-row no-gutter justify-center items-center"
                  },
                  [
                    _c("div", { staticClass: "vx-col lg:block lg:w-1/2" }, [
                      _c("img", {
                        staticClass: "mx-auto",
                        attrs: {
                          src: require("@/assets/images/pages/login.png"),
                          alt: "login"
                        }
                      })
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg pb-8"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "p-8 login-tabs-container" },
                          [
                            _c("div", { staticClass: "vx-card__title mb-10" }, [
                              _c("h4", { staticClass: "mb-4" }, [
                                _vm._v("Cambiar Clave")
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Por políticas de seguridad es necesario que actualices tu clave."
                                )
                              ])
                            ]),
                            _c("ChangePasswordForm", {
                              attrs: { isUpdateBySystem: true }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }